<template>
  <WdsAlert v-if="validationErrors && Object.keys(validationErrors).length" error class="tw-mb-2">
    <ul class="tw-mb-0">
      <li v-for="validationError in validationErrors" :key="validationError">
        {{ validationError }}
      </li>
    </ul>
  </WdsAlert>
  <WdsAlert v-if="displayGenericErrorMessage" error class="tw-mb-2">
    {{ $t('An error occurred') }}
  </WdsAlert>
  <WdsText class="tw-mb-2">{{ $t('Send an invitation to') }} {{ worker.name }}?</WdsText>
  <div class="tw-flex tw-justify-end tw-gap-sm">
    <WdsButton @click="$emit('cancel')">{{ $t('Cancel') }}</WdsButton>
    <WdsButton class="tw-float-right tw-items-center tw-gap-sm" primary @click="handleClick">
      <WdsSpinner v-if="createJobShareLoading" indeterminate />
      {{ $t('Send') }}
    </WdsButton>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { WdsAlert, WdsText, WdsButton, WdsSpinner } from '@worksome/wds-components'
import { useMutation } from '@vue/apollo-composable'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { CreateJobShareMutation } from '@/components/Job/Share/graphql/mutations'
import useApolloError from '@/composables/useApolloError'
import { Worker } from '@/gql/graphql'

const props = defineProps<{
  jobId: string
  worker: Worker
}>()

const emit = defineEmits(['cancel', 'candidate-updated'])

const {
  loading: createJobShareLoading,
  mutate: mutateCreateJobShare,
  error: errorCreateJobShare,
} = useMutation(CreateJobShareMutation, {
  clientId: 'publicApi',
})

const { validationErrors } = useApolloError(errorCreateJobShare)

const displayGenericErrorMessage = ref(false)

const handleClick = async () => {
  displayGenericErrorMessage.value = false
  await mutateCreateJobShare({
    input: {
      job: props.jobId,
      accounts: [props.worker.id],
    },
  })
    .then(() => emit('candidate-updated'))
    .catch(() => {
      displayGenericErrorMessage.value = true
    })
}
</script>
